import {
	createDisclosure as createSharedDisclosure,
	type DisclosureSpec,
} from "@scripts/disclosure";

import { takesPanel } from "./SiteHeader.focus";

export const createDisclosure = (spec: Omit<DisclosureSpec, "retainsFocus">): void => {
	createSharedDisclosure({ ...spec, retainsFocus: takesPanel });
};
